import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FieldError } from '../../../../hybrid/wrappers';
import { initFormHandlers } from '../../utils/formUtils';
import FromInputTitle from '../FormFieldTitle/FormFieldTitle';
import css from './FormDisabledInfo.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../common/utils/styles';
// import { generateUniqueId } from '../../../../common/utils/utils';

const FormInputDisabled = ({
    attribute,
    html,
    hint,
    placeholder,
    required,
    title,
    handlers = {},
    compStyle,
    value,
    type,
    errors,
    errorEditor,
    fieldsErr
}) => {
    const [val, setVal] = useState(value || '');
    useEffect(() => {
        setVal(value || '');
    }, [setVal, value]);
    const initHandlers = useMemo(
        () => initFormHandlers(handlers, attribute, val, type, errors),
        [handlers, attribute, val, type, errors]
    );
    const componentConfig = {
        ...initHandlers,
        type: 'hidden',
        value: val,
        required,
        placeholder: placeholder || '',
        autoComplete: 'new-password',
        maxLength: 150,
        disabled: true
    };
    const { stylers, classes } = generateCompStylers(compStyle);

    return (
        <div style={stylers.wrapper} className={classnames(css.formGroup, classes.wrapper)}>
            {!!title ? (
                <FromInputTitle type={type} errors={errors} title={title} compStyle={compStyle} hint={hint} required={required} />
            ) : null}
            <input style={{ display: 'none' }} {...componentConfig} />
            {
                <div
                    // key={generateUniqueId()}
                    style={errorEditor && fieldsErr && fieldsErr[errorEditor.fieldName] ? { color: errorEditor.colorError } : {}}
                    className={
                        !(errorEditor && fieldsErr && fieldsErr[errorEditor.fieldName]) && errors?.length
                            ? css.formTitleError
                            : ''
                    }
                >
                    {html ? html : null}
                </div>
            }
            {errors && errors.length
                ? errors.map((err, idx) => (
                      <FieldError className={compStyle?.error} key={`${attribute}${idx}`}>
                          {err}
                      </FieldError>
                  ))
                : null}
        </div>
    );
};
FormInputDisabled.propTypes = {
    attribute: PropTypes.string,
    html: PropTypes.node,
    hint: PropTypes.node,
    placeholder: PropTypes.node,
    required: PropTypes.bool,
    title: PropTypes.object,
    handlers: PropTypes.object,
    compStyle: PropTypes.object,
    value: PropTypes.string,
    type: PropTypes.string,
    errors: PropTypes.array,
    errorEditor: PropTypes.object,
    fieldsErr: PropTypes.object
};
export default FormInputDisabled;
